interface BaseURL {
  BASE_URL_PHP: string;
  BASE_JAVA_URL: string;
  BASE_JAVA_WORK_URL: string;
}
interface BasicNode {
  node_1: string;
  node_2: string;
}
const baseUrl = new Object() as BaseURL;
const basicNode = new Object() as BasicNode;

baseUrl.BASE_URL_PHP = process.env.VUE_APP_HTTP_URL;
baseUrl.BASE_JAVA_URL = process.env.VUE_APP_HTTP_JAVA_URL;
baseUrl.BASE_JAVA_WORK_URL = process.env.VUE_APP_HTTP_JAVA_WORK_URL;
basicNode.node_1 = "basic/web/index.php/";
basicNode.node_2 = "userCenter/web/index.php/";

export default {
  baseUrl,
  basicNode,
};
